import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { Alert, IconButton, Snackbar } from "@mui/material";
import { useDispatchWrapper } from "../../hooks";
import { hideMessage } from "../../redux/messages/messagesActions";
import CloseIcon from "@mui/icons-material/Close";
import LoadingDialog from "../Dialogs/LoadingDialog";
import { SuccessDialog } from "../Dialogs/SuccessDialog";
import { SuccessErrorDialog } from "../MessagesDialogs/SuccessErrorDialog/SuccessErrorDialog";
import ConvertedLoadingDialog from "../Dialogs/ConvertingLoadingDialog";
import LoadingDialogWithMessage from "../Dialogs/LoadingDialogWithMessage";

/*************  ✨ Codeium Command ⭐  *************/
/**
 * MessageBox is a component that displays a message to the user.
 * It is a top level component and should be placed in the root of the app.
 *
 * The message box can be used to display messages to the user, such as errors or success messages.
 * It can also be used to display a loading indicator while a task is being performed.
 *
 * The message box can be configured to display the message in one of two ways:
 * - as a snackbar
 * - as a dialog
 *
 * The message box is connected to the message slice of the redux store.
 * The message slice is an object that contains the following properties:
 * - item: the message to be displayed
 *   - type: the type of message (error, success, etc.)
 *   - message: the message to be displayed
/******  0d3e37d5-60d9-4d54-9bd0-d1d90c46c553  *******/

export const MessageBox: React.FC = () => {
  
  const { item, saveLoader, convertLoader, loader_with_message } = useSelector(
    (storeState: IStoreState) => storeState.message,
  );


  const dispatch = useDispatchWrapper();

  const handleClearMessage = () => {
    dispatch(hideMessage());
  };

  return (
    <>
      {item && item.displayAs === "snackbar" && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={true}
          autoHideDuration={5000}
          onClose={handleClearMessage}
          key={"topright"}
        >
          <Alert
            severity={item.type}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleClearMessage}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {item.message}
          </Alert>
        </Snackbar>
      )}

      {item && item.displayAs === "dialog" && (
        <SuccessErrorDialog
          open={true}
          type={item.type}
          content={item.message}
          onClose={handleClearMessage}
        />
      )}

      {saveLoader ? (
        <LoadingDialog open={!!saveLoader} />
      ) : convertLoader ? (
        <ConvertedLoadingDialog open={convertLoader} />
      ) : loader_with_message.loading ? (
        <LoadingDialogWithMessage
          open={loader_with_message.loading}
          label={loader_with_message.message || "Loading"}
        />
      ) : null}
    </>
  );
};
